import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot, FileSpreadsheet, ShieldCheck } from 'lucide-react';

const StatsSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="mx-auto max-w-5xl border-t py-12">
            <div className="overflow-hidden rounded-2xl border border-purple-100 bg-gradient-to-br from-purple-50 via-white to-blue-50 px-6 py-8 sm:px-10">
                <div className="mx-auto mb-8 max-w-2xl text-center">
                    <p className="mb-2 text-sm font-semibold uppercase tracking-wider text-purple-600">
                        {t('home.dataFooter.eyebrow')}
                    </p>
                    <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">
                        {t('home.dataFooter.title')}
                    </h2>
                    <p className="mt-3 text-gray-600">
                        {t('home.dataFooter.description')}
                    </p>
                </div>

                <div className="grid gap-4 md:grid-cols-3">
                    <FooterItem
                        icon={<FileSpreadsheet className="h-5 w-5" />}
                        title={t('home.dataFooter.googleSheets.title')}
                        description={t('home.dataFooter.googleSheets.description')}
                    />
                    <FooterItem
                        icon={<ShieldCheck className="h-5 w-5" />}
                        title={t('home.dataFooter.ownership.title')}
                        description={t('home.dataFooter.ownership.description')}
                    />
                    <FooterItem
                        icon={<Bot className="h-5 w-5" />}
                        title={t('home.dataFooter.ai.title')}
                        description={t('home.dataFooter.ai.description')}
                    />
                </div>
            </div>
        </section>
    );
};

function FooterItem({ icon, title, description }: {
    icon: React.ReactNode;
    title: string;
    description: string;
}) {
    return (
        <div className="rounded-xl border border-white/80 bg-white/80 p-5 shadow-sm backdrop-blur-sm">
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-purple-100 text-purple-600">
                {icon}
            </div>
            <h3 className="font-semibold text-gray-900">{title}</h3>
            <p className="mt-1.5 text-sm leading-6 text-gray-600">{description}</p>
        </div>
    );
}

export default StatsSection;
